<template>
  <el-table-column
    prop="roles"
    label="Jogkör(ök)"
    min-width="150"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <el-tooltip v-if="scope.row.roles.length > 1" placement="top" style="max-width: 300px;" popper-class="permission-info-tooltip">
        <div slot="content">
          {{ scope.row.roles.map(p => p.name).join(', ') }}
        </div>
        <el-tag size="small">{{ scope.row.roles.length }} jogkör</el-tag>
      </el-tooltip>

      <el-tag v-if="scope.row.roles.length === 1" size="small">{{ scope.row.roles[0].name }}</el-tag>
      <el-tag v-if="scope.row.roles.length === 0" type="danger" size="small">Nincs jogkör</el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'roles',
};
</script>
